<app-ofwca-add
  [partnerObject]="partnerObject"
  [facilityObject]="facilityObject"
  (ofwcaCreated)="closeDialog($event)"
  [dialogRef]="dialogRef"
></app-ofwca-add>
